export const dark = {
  title: 'dark',
  colors: {
    c01: '#7f47dd',
    c02: '#015D7F',
    c03: '#585858',
    c04: '#FFFFFF',
    c05: '#FFFFFF',
    c06: '#FBFBFB',
    c07: '#1C1C1C',
    c08: '#d3d3d3',
    c09: '#0000FF',
    c10: '#FFFF00',
    c11: '#DC3545',
    c12: 'rgba(0, 0, 0, 0.2)',
    c13: '#FF0000',
    c14: '#5E5187',
    c15: '#3A4365',
    c16: '#0B0F24',
    c17: '#005372',
    c18: '#3FC248',
    c19: '#2196f3',
    c20: '#020e42',
    bgLogin: '/assets/fundoD.png',
    lunch: '/assets/lunch.png',
    bgStop: '/assets/stop-sign-svgrepo-com.svg',
    bgAccount: '/assets/2313903-ai-bg.png',
    bgIllust: '/assets/2313903-ai.png',
  }
};